// InvitoSfida.tsx — la sfida è creata e l'amico non è ancora arrivato (v019, nuova grafica): titolo, anteprima
// dell'invito come la vedrà lui, «Condividi la sfida» (menu del telefono: WhatsApp, Telegram…), «Copia link»,
// «Mostra QR». E il posto dell'amico con il punto di domanda, finché non entra.
import { condividi as condividiNativo } from "../servizi/nativo.ts";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Avatar } from "../componenti/Avatar.tsx";
import { CodiceQR } from "../componenti/CodiceQR.tsx";
import { Finestra } from "../componenti/Finestra.tsx";
import { useAvatar } from "../servizi/account.ts";
import { MARCHIO } from "../costanti.ts";
import { InvitaRubrica } from "../componenti/InvitaRubrica.tsx";

const ATTESA_COPIATO_MS = 2000;

export function InvitoSfida({ link, nome }: { link: string; nome: string }) {
  const { t } = useTranslation();
  const avatar = useAvatar();
  const [copiato, setCopiato] = useState(false);
  const [qr, setQr] = useState(false);
  const testo = t("gioco.messaggio_condividi");

  const copia = async () => {
    try {
      await navigator.clipboard.writeText(`${testo} ${link}`);
      setCopiato(true);
      setTimeout(() => setCopiato(false), ATTESA_COPIATO_MS);
    } catch {
      // appunti non disponibili: resta «Condividi» e il QR
    }
  };
  const condividi = async () => {
    // v030: nelle app il foglio di condivisione del sistema, nel browser navigator.share; se nessuno dei due, si copia
    if (await condividiNativo({ titolo: MARCHIO, testo, url: link })) return;
    await copia();
  };

  return (
    <div className="ld-invito">
      <h2 className="ld-invito-titolo">
        <span className="ld-giallo ld-blocco">{t("invito.titolo_1")}</span> <span className="ld-blocco">{t("invito.titolo_2")}</span>
      </h2>
      <p className="ld-invito-sotto">{t("invito.sotto")}</p>
      <div className="ld-invito-carta">
        <Avatar quale={avatar} dimensione={78} anello />
        <div className="ld-invito-carta-testo">
          <strong>{t("invito.ti_sfida", { nome })}</strong>
          {/* v026: niente link lungo, solo il marchio (come nel riferimento): il link sta nei pulsanti */}
          <span className="ld-invito-link" translate="no" data-link={link}>
            <span aria-hidden="true">👑</span> {MARCHIO.toLowerCase()}
          </span>
        </div>
      </div>
      <button type="button" className="ld-cta ld-cta-centrata ld-invito-condividi" onClick={() => void condividi()}>
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="18" cy="5" r="3" />
          <circle cx="6" cy="12" r="3" />
          <circle cx="18" cy="19" r="3" />
          <path d="M8.6 10.6l6.8-4M8.6 13.4l6.8 4" />
        </svg>
        {t("invito.condividi")}
      </button>
      {/* v046: dalla rubrica del telefono, a chi vuoi (SMS o WhatsApp già scritto) */}
      <InvitaRubrica link={link} testo={testo} />
      <div className="ld-invito-secondari">
        <button type="button" className="pulsante" onClick={() => void copia()} aria-live="polite">
          {copiato ? t("gioco.copiato") : t("invito.copia")}
        </button>
        <button type="button" className="pulsante" onClick={() => setQr(true)}>
          {t("invito.qr")}
        </button>
      </div>
      <Finestra aperta={qr} titolo={t("invito.qr_titolo")} onChiudi={() => setQr(false)}>
        <div className="ld-qr-contenitore">{qr && <CodiceQR testo={link} etichetta={t("invito.qr_etichetta")} />}</div>
      </Finestra>
    </div>
  );
}

/** Il posto dell'amico che non è ancora entrato: punto di domanda e archi che girano. */
export function PostoAmico() {
  const { t } = useTranslation();
  return (
    <div className="ld-posto-amico" role="status">
      <div className="ld-posto-cerchi" aria-hidden="true">
        <span className="ld-arco ld-arco-1" />
        <span className="ld-arco ld-arco-2" />
        <Avatar quale="mistero" dimensione={112} classe="ld-posto-avatar" />
      </div>
      <p className="ld-posto-testo">
        {t("invito.aspetto")}
        <span className="ld-puntini" aria-hidden="true">
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </span>
      </p>
      <p className="ld-posto-nota">{t("invito.aspetto_nota")}</p>
    </div>
  );
}
